export const validateDiscordSubmission = (input: {
  name?: string | null;
  sku?: string | null;
  msrp: string;
  salePrice: string;
}) => {
  if (!input.name || input.name.trim() === "") {
    return "Product name is required";
  }
  if (!input.sku || input.sku.trim() === "") {
    return "Product barcode is required";
  }
  const msrpValue = parseFloat(input.msrp);
  const salePriceValue = parseFloat(input.salePrice);
  if (Number.isNaN(msrpValue) || Number.isNaN(salePriceValue)) {
    return "Please enter valid price values";
  }
  if (msrpValue < 0 || salePriceValue < 0) {
    return "Prices cannot be negative";
  }
  return null;
};

export const getStoreConfig = (retailer: string) => {
  const storeName =
    retailer === "home_depot"
      ? "home_depot"
      : retailer === "dollar_general"
      ? "dollar_general"
      : "walmart";
  const textChannel =
    retailer === "home_depot"
      ? "<#1332332468942143548>"
      : retailer === "dollar_general"
      ? "<#1332332722030510131>"
      : "<#1332332722030510131>";
  return { storeName, textChannel };
};

export const computeSavings = (msrp: string, salePrice: string) => {
  const msrpValue = parseFloat(msrp);
  const saleValue = parseFloat(salePrice);
  if (Number.isNaN(msrpValue) || Number.isNaN(saleValue)) return null;
  const amount = msrpValue - saleValue;
  const percent =
    msrpValue > 0 ? Math.round((amount / msrpValue) * 100) : 0;
  return { amount, percent };
};
